import { ButtonBase } from '@mui/material'
import { SxProps } from '@mui/system'
import { Icons } from 'utoniq-ui'

import { Organism } from '@/core/architecture'

import { ItemProps } from '../ItemImage'

export type ItemTrashProps = {
  selected: ItemProps | null
  sx?: SxProps
  onClick: () => void
}

export const ItemTrash: Organism<ItemTrashProps> = ({
  selected,
  sx,
  onClick,
}) => (
  <ButtonBase
    sx={{
      width: '100%',
      bgcolor: 'grey.50',
      color: 'primary.main',
      minHeight: 70,
      opacity: !selected ? 0.5 : 1,
      ...sx,
    }}
    disabled={!selected}
    onClick={onClick}
  >
    <Icons.Trash color="inherit" />
  </ButtonBase>
)
